module.exports = __webpack_public_path__ + "img/@logo_miraeasset@3x.088358f0.png";